import { mapGetters, mapActions } from 'vuex'
import StageModule, { MODULE_NAME } from './index'

const StageMixin = {
  namespaced: StageModule.namespaced,
  computed: { ...mapGetters(MODULE_NAME, Object.keys(StageModule.getters)) },
  methods: { ...mapActions(MODULE_NAME, Object.keys(StageModule.actions)) }
}

export default StageMixin



// WEBPACK FOOTER //
// ./src/store/module/stage/mixin.js